import { useDisclosure } from '@heroui/react';
import { useState, useCallback } from 'react';
import type { RoleItem } from '@/types';

export function useRoleActions() {
  const { isOpen: isPermissionsModalOpen, onOpen: onPermissionsModalOpen, onOpenChange: onPermissionsModalOpenChange } = useDisclosure();
  const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onOpenChange: onDeleteModalOpenChange } = useDisclosure();

  const [selectedRole, setSelectedRole] = useState<RoleItem | null>(null);

  const openCreateModal = useCallback(() => {
    setSelectedRole(null);
    onPermissionsModalOpen();
  }, [onPermissionsModalOpen]);

  const openEditModal = useCallback((role: RoleItem) => {
    setSelectedRole(role);
    onPermissionsModalOpen();
  }, [onPermissionsModalOpen]);

  const openDeleteModal = useCallback((role: RoleItem) => {
    setSelectedRole(role);
    onDeleteModalOpen();
  }, [onDeleteModalOpen]);

  const closePermissionsModal = useCallback(() => {
    setSelectedRole(null);
    onPermissionsModalOpenChange();
  }, [onPermissionsModalOpenChange]);

  const closeDeleteModal = useCallback(() => {
    setSelectedRole(null);
    onDeleteModalOpenChange();
  }, [onDeleteModalOpenChange]);

  return {
    // Permissions modal (unified for create/edit)
    isPermissionsModalOpen,
    selectedRole,
    openCreateModal,
    openEditModal,
    closePermissionsModal,
    onPermissionsModalOpenChange,

    // Delete modal
    isDeleteModalOpen,
    openDeleteModal,
    closeDeleteModal,
    onDeleteModalOpenChange
  };
}
